import axios from "axios";
import { useEffect, useLayoutEffect, useState } from "react";
import Loader from "react-loader-spinner";

import SearchFilter from "../../components/fragments/SearchFilter";
import NavBar from "../../components/fragments/NavBar";
import HeroBanner from "../../components/fragments/HeroBanner";
import LatestSlider from "../../components/fragments/LatestSlider";
import BrandName from "../../components/fragments/BrandName";
import Footer from "../../components/fragments/Footer";

import background from "../../assets/img/temp-background.jpg";
import video from "../../assets/video/pp-video-bg.mp4";
import { LoaderWrapper } from "../../components/styles/Loader";
import ElfsightWidget from "../../components/fragments/ElfsightWidget";
import { Button } from "../../components/styles/Button";

import { useStaticSeo } from "../../hooks/useSeo";
import { STATIC_SEO } from "../../data/seo";
import useJsonLd from "../../hooks/useJsonLd";
import { organisationSchema } from "../../data/structuredData";

export default function Home() {
    useStaticSeo(STATIC_SEO["/"]);
    useJsonLd(organisationSchema());
    const [properties, setProperties] = useState([]);

    // Configure axios proxy
    const axiosInstance = axios.create({ baseURL: process.env.REACT_APP_API_URL });

    useEffect(() => {
        const fetchProperties = async () => {
            await axiosInstance.get("properties/available").then((res) => {
                setProperties(res.data.properties);
            });
        };
        fetchProperties();
    }, []);

    // useLayoutEffect(() => {
    //     document.getElementById("root").scrollTo(0, 0);
    // }, []);

    return (
        <>
            <NavBar location="public" />

            <LatestSlider properties={properties} />

            <HeroBanner
                title={
                    <>
                        think <BrandName />.. think <BrandName people />.
                    </>
                }
                tagline="Exceptional Results Across South West London."
                subtitle={[
                    "Whether you're looking to sell for the best possible price or maximize your rental yields without the administrative headache, you need a local partner who delivers. At Property People, we combine decades of hands-on South West London expertise with cutting-edge marketing, rigorous tenant vetting, and proactive management.",
                    "From high-performing HMOs and residential portfolios to bespoke sales and seamless lettings, we handle every detail so you don't have to. We don't just list properties—we protect your investment, streamline your compliance under the latest regulations, and secure the right buyers or tenants fast.",
                    "Tired of empty promises and poor communication? Call us today for a no-obligation appraisal of your home, or let’s discuss how we can elevate your portfolio's performance.",
                ]}
                links={[
                    { label: "Lettings", to: "/lettings-guide" },
                    { label: "Sales", to: "/sales-guide" },
                    { label: "Management", to: "/management-guide" },
                ]}
                video={video}
                background={background}
                showRating={false}
            />

            <a
                href="https://www.onthemarket.com/instant-valuation/property-people/"
                target="_blank"
                rel="noreferrer"
            >
                <Button light type="button">
                    Instant Valuation
                </Button>
            </a>
            
            <ElfsightWidget />

            {properties.length !== 0 ? (
                <SearchFilter properties={properties} />
            ) : (
                <LoaderWrapper>
                    <Loader type="Puff" color="#A2DEF9" height={60} width={60} />
                </LoaderWrapper>
            )}

            <Footer />
        </>
    );
}
